// 9fbef606107a605d69c0edbcd8029e5d
import React, { useEffect, useRef } from 'react';
import { PropTypes } from 'prop-types';
import Router from 'next/router';
import { getPageNameUsingURL, isClient, getPageTypeFromUrl } from '@tcp/core/src/utils';
import { getMonetateEnabledFlag } from '@tcp/core/src/components/common/molecules/Recommendations/container/Recommendations.selector';

// TODO: Remove connect once react-redux@7 is in use
import { connect } from 'react-redux';
import {
  fetchAbTestData,
  fetchDyABTestsData,
} from '@tcp/core/src/components/common/molecules/abTest/abTest.actions';
import { getIsDyAbTestEnabled } from '@tcp/core/src/reduxStore/selectors/session.selectors.js';
import dyRequestContextMap from '@tcp/core/src/components/common/molecules/abTest/utils/dyRequestContext';

/**
 * A component that sets up event handlers for when the
 * route changes, and dispatches Redux actions with
 * payloads for A/B Test
 */
function AbTestPathTracker({ dispatch, MONETATE_ENABLED, isDyAbTestEnabled }) {
  const divRef = useRef(null);
  const setAbtestScript = (html) => {
    if (html) {
      const slotHtml = document.createRange().createContextualFragment(html); // Create a 'tiny' document and parse the html string
      divRef.current.innerHTML = ''; // Clear the container on path change
      divRef.current.appendChild(slotHtml);
    }
  };
  const handlePathChange = (pathname) => {
    setTimeout(() => {
      const LUX = (isClient() && window.LUX) || {};
      if (Object.keys(LUX) && (typeof LUX.send === 'function' || typeof LUX.init === 'function')) {
        LUX.send();
        LUX.init();
      }
      if (isDyAbTestEnabled) {
        const payload = {
          ...dyRequestContextMap[getPageTypeFromUrl(pathname)](),
          pathname,
        };
        dispatch(fetchDyABTestsData(payload));
      } else {
        const action = {
          payload: {
            abTest: {},
            pathname,
            setAbtestScript,
            MONETATE_ENABLED,
            page: getPageNameUsingURL(pathname),
          },
        };
        dispatch(fetchAbTestData(action));
      }
    }, 0);
  };
  useEffect(() => {
    // Track future route changes
    Router.events.on('routeChangeStart', handlePathChange);
    // Stop tracking route changes on unmount
    return () => Router.events.off('routeChangeStart', handlePathChange);
  }, []);

  return <div id="inject-abtest-script" ref={divRef} />;
}

AbTestPathTracker.propTypes = {
  dispatch: PropTypes.func.isRequired,
  MONETATE_ENABLED: PropTypes.bool,
};

AbTestPathTracker.defaultProps = {
  MONETATE_ENABLED: true,
};

function mapStateToProps(state) {
  const MONETATE_ENABLED = getMonetateEnabledFlag(state);
  return {
    MONETATE_ENABLED,
    isDyAbTestEnabled: getIsDyAbTestEnabled(),
  };
}

export default connect(mapStateToProps)(AbTestPathTracker);
